export function activeEditorLocation(state) {
  return state.activeEditorLocation;
}

export function activeEditorId(state) {
  return state.activeEditorId;
}

export function selectedPreviewCard(state) {
  return state.selectedPreviewCard;
}

export function selectedPreviewPageIndex(state) {
  return state.selectedPreviewPageIndex;
}

export function isStudentAssignmentPreview(state) {
  return state.isStudentAssignmentPreview;
}

export function isClassAssignmentPreview(state) {
  return state.isClassAssignmentPreview;
}

export function isPagePreview(state) {
  return state.isPagePreview;
}

export function getRouteName(state) {
  return state.route.name;
}

export function getRoute(state) {
  return state.route.params;
}

export function getRouteParams(state) {
  return state.route.params;
}

export function getRouteQuery(state) {
  return state.route.query;
}

export function getBusy(state) {
  return state.busy;
}



// WEBPACK FOOTER //
// ./src/store/getters.js